import { AvailableTimesUnit } from "types/available-times";
import { WebRuleBookingType } from "types/web-rule";

/**
 * Filters and sorts available times data
 * @param availableTimesData The data from the API
 * @returns Sorted and filtered sections
 */
export function filterAndSortAvailableTimes(availableTimesData: AvailableTimesUnit[] | null) {
    if (!Array.isArray(availableTimesData) || availableTimesData.length === 0) {
        return [];
    }

    const availableTimesCopy = { ...availableTimesData[0] };
    let availableTimes = availableTimesCopy.sections;

    // Do not display sections with no active web rules
    availableTimes = availableTimes.filter((section) => section.timeSets.length > 0);

    availableTimes.forEach((section) => {
        // Mark sections as disabled if all their rules or times are unavailable
        section.disabled = section.timeSets.every(
            (timeSet) => timeSet.isClosed || timeSet.times.length === 0
        );

        // Filter out non-booking type timesets
        section.timeSets = section.timeSets.filter(
            (timeSet) => timeSet.bookingType === WebRuleBookingType.Booking
        );

        section.timeSets.forEach((timeSet) => {
            // Filter out disabled times
            timeSet.times = timeSet.times.filter((time) => !time.disabled);
        });
    });

    // Sort sections on sort order
    availableTimes.sort((a, b) => a.sortOrder - b.sortOrder);

    // Sort sections to show disabled sections last
    availableTimes.sort((a, b) => (a.disabled === b.disabled ? 0 : a.disabled ? 1 : -1));

    return availableTimes;
}
